import { Hub } from 'react-signalr/lib/signalr/types';

export enum ServerOperations {
  ExamTaskGroupSolutionScoreProcessed = 'ExamTaskGroupSolutionScoreProcessed',
}

export type Operations = {
  [ServerOperations.ExamTaskGroupSolutionScoreProcessed]: (id: string) => Promise<void>;
};

export enum CallbackMethodNames {
  SendFromServer = 'SendFromServer',
  ExamTaskGroupSolutionScoreProcessed = 'ExamTaskGroupSolutionScoreProcessed',
}

export type Callbacks = {
  [CallbackMethodNames.SendFromServer]: (message: string) => void;
  [CallbackMethodNames.ExamTaskGroupSolutionScoreProcessed]: (message: { id: string }) => void;
};

export interface ExamTaskGroupSolutionDownloadSignalR extends Hub {
  methodsName: ServerOperations;
  methods: Operations;

  callbacksName: CallbackMethodNames;
  callbacks: Callbacks;
}
